import React from "react";
import BaseList from "../../components/BaseList";
import Toggle from "../../components/DataGrid/toggle.js";

const formatarHorario = (inicio, fim) => {
  if (!inicio && !fim) return "-";
  return `${inicio || "00:00"} - ${fim || "23:59"}`;
};

const getColumns = ({ podeEditar, navigate, baseRoute, onToggleStatus }) => {
  const columns = [
    { field: "loginName", header: "Login SQL", sortable: true },
    { field: "usuarioWebNome", header: "Usuário Web", sortable: true },
    {
      key: "horarioBloqueio",
      header: "Horário Bloqueio",
      render: (row) => formatarHorario(row.horarioBloqueioInicio, row.horarioBloqueioFim),
    },
    {
      key: "bancos",
      header: "Bancos",
      width: "100px",
      className: "text-center",
      headerClassName: "text-center",
      render: (row) => row.quantidadeBancos || 0,
    },
    {
      key: "ativo",
      header: "Ativo",
      className: "text-center",
      headerClassName: "text-center",
      width: "100px",
      render: (row) => (
        <div onClick={(e) => e.stopPropagation()}>
          <Toggle
            value={row.ativo}
            onChange={() => onToggleStatus(row.id, row.ativo)}
            disabled={!podeEditar}
          />
        </div>
      ),
    },
  ];

  if (podeEditar) {
    columns.push({
      key: "acoes",
      header: "Ações",
      width: "100px",
      className: "text-center",
      headerClassName: "text-center",
      render: (row) => (
        <button
          onClick={(e) => {
            e.stopPropagation();
            navigate(`${baseRoute}/${row.id}`);
          }}
          className="p-2 text-gray-600 hover:text-slate-900 hover:bg-gray-100 rounded"
          title="Editar"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
          </svg>
        </button>
      ),
    });
  }

  return columns;
};

export default function ControleUsuarioList() {
  return (
    <BaseList
      titulo="Logins SQL Server"
      endpoint="controle-usuarios"
      baseRoute="/controle-usuarios"
      getColumns={getColumns}
      permissoes={{
        criar: "acessosbd.criar",
        editar: "acessosbd.editar",
        remover: "acessosbd.remover",
      }}
      emptyMessage="Nenhum login SQL encontrado"
      novoButtonText="Novo Login SQL"
      emptyButtonText="Cadastrar primeiro login"
    />
  );
}